module.exports = __webpack_public_path__ + "static/media/pcs-logo.a4fa9c41.png";